import { IventisErrorBoundaryWithToast } from "@iventis/error-boundaries";
import { toast } from "@iventis/toasts/src/toast";
import { Body2, InteractiveElement, SectionalHeader, formPadding, sectionalMargin, styled } from "@iventis/styles";
import { Content } from "@iventis/translations";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import React, { FunctionComponent, PropsWithChildren } from "react";

interface DashboardWidgetProps {
    title: string;
    onClick: () => void;
}

export const DashboardWidget: FunctionComponent<PropsWithChildren<DashboardWidgetProps>> = ({ title, onClick, children }) => {
    const translate = useIventisTranslate();

    return (
        <StyledErrorBoundary toast={toast}>
            <StyledContainer>
                <StyledHeaderContainer>
                    <SectionalHeader>{title}</SectionalHeader>
                    <StyledButon onClick={onClick}>
                        <Body2>{translate(Content.common.buttons.see_all)}</Body2>
                    </StyledButon>
                </StyledHeaderContainer>
                {children}
            </StyledContainer>
        </StyledErrorBoundary>
    );
};

const StyledErrorBoundary = styled(IventisErrorBoundaryWithToast)`
    height: auto;
`;

const StyledHeaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: ${sectionalMargin} 0 ${sectionalMargin} 0;
`;

const StyledButon = styled(InteractiveElement)`
    text-decoration: underline;
`;

const StyledContainer = styled.section`
    padding: ${formPadding};
    display: flex;
    flex-direction: column;
`;
